import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMachineTemplateIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12 12",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M4.962 9.237a.9.9 0 0 1-1.273 0L1.762 7.313a.9.9 0 0 1 0-1.273L5.011 2.79a1 1 0 0 1 .707-.292h1.783a1 1 0 0 1 1 1v1.78a1 1 0 0 1-.292.707z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M10.502 3.999v1.9a1 1 0 0 1-.293.707L7.377 9.438"
	})]
});
export default SvgMachineTemplateIcon;
